import axios from 'axios'
import { CATALOGO_ENDPOINT } from '../../endpoints'

export const getStocksListByCarId = async (id) => {
  try {
    return await axios.get(`${CATALOGO_ENDPOINT}/${id}/stocks`)
  } catch (error) {
    throw new Error(error)
  }
}
